/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateExperimentRequest
 */
export interface UpdateExperimentRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateExperimentRequest
   */
  name: string;
}

/**
 * Check if a given object implements the UpdateExperimentRequest interface.
 */
export function instanceOfUpdateExperimentRequest(
  value: object,
): value is UpdateExperimentRequest {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function UpdateExperimentRequestFromJSON(
  json: any,
): UpdateExperimentRequest {
  return UpdateExperimentRequestFromJSONTyped(json, false);
}

export function UpdateExperimentRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateExperimentRequest {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
  };
}

export function UpdateExperimentRequestToJSON(
  json: any,
): UpdateExperimentRequest {
  return UpdateExperimentRequestToJSONTyped(json, false);
}

export function UpdateExperimentRequestToJSONTyped(
  value?: UpdateExperimentRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
  };
}
